import isNumber from 'lodash/isNumber';

export default (row = [], field, direction) => {
	const compare = direction === 'desc'
		? (a, b) => Number(a) < Number(b)
		: (a, b) => Number(a) > Number(b);

	return row.sort((a, b) => !a || !isNumber(a[field]) || compare(a[field], b[field]) ? 1 : -1);
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/sortByNumber.js